// 常量路由
export const constantRoutes = [
  {
    path: "/",
    redirect: "/home",
    meta: {
      hidden: true,
    },
  },
  {
    path: "/login",
    meta: {
      hidden: true,
    },
    component: () => import("@/views/login/index"),
  },
  {
    path: "/home",
    name: "Home",
    meta: {
      icon: "el-icon-s-home",
      name: "首页",
      affix: true,
    },
    component: () => import("../views/home/index.vue"),
  },
];

// 任意路由
export const anyRoutes = [
  //
];

// 动态路由
export const asyncRoutes = () => [
  {
    path: "/goods",
    name: "Goods",
    redirect: "/goods/list",
    meta: {
      icon: "el-icon-s-goods",
      name: "商品管理",
    },
    component: () => import("@/views/goods/index.vue"),
    children: [
      {
        path: "/goods/list",
        name: "GoodsList",
        component: () => import("@/views/goods/goods-list/list.vue"),
        meta: {
          name: "商品列表",
          keepAlive: true,
        },
      },
      {
        path: "/goods/list/add",
        name: "GoodsAdd",
        component: () => import("@/views/goods/goods-list/add-edit.vue"),
        meta: {
          name: "创建商品",
          hidden: true,
          keepAlive: false,
          activeMenu: "/goods/list",
        },
      },
      {
        path: "/goods/list/edit/:id?",
        name: "GoodsEdit",
        component: () => import("@/views/goods/goods-list/add-edit.vue"),
        meta: {
          name: "编辑商品",
          hidden: true,
          keepAlive: false,
          activeMenu: "/goods/list",
        },
      },
      {
        path: "/goods/category",
        name: "GoodsCategory",
        component: () => import("@/views/goods/goods-category/list.vue"),
        meta: {
          name: "商品分类",
        },
      },
      {
        path: "/goods/category/add/:id?/:parentId?",
        name: "GoodsCategoryAdd",
        component: () => import("@/views/goods/goods-category/add-edit.vue"),
        meta: {
          name: "新增商品分类",
          hidden: true,
          activeMenu: "/goods/category",
        },
      },
      {
        path: "/goods/category/edit/:id?/:parentId?",
        name: "GoodsCategoryEdit",
        component: () => import("@/views/goods/goods-category/add-edit.vue"),
        meta: {
          name: "编辑商品分类",
          hidden: true,
          activeMenu: "/goods/category",
        },
      },
    ],
  },
  {
    path: "/member",
    name: "Member",
    redirect: "/member/member-list",
    component: () => import("@/views/member/index.vue"),
    meta: {
      name: "用户管理",
      icon: "el-icon-user-solid",
    },
    children: [
      {
        path: "/member/member-list",
        name: "MemberList",
        component: () => import("@/views/member/member-list/list.vue"),
        meta: {
          name: "用户列表",
          keepAlive: true,
        },
      },
      {
        path: "/member/white-list",
        name: "WhiteList",
        component: () => import("@/views/member/white-list/list.vue"),
        meta: { name: "白名单列表", keepAlive: true },
      },
      {
        path: "/member/white-list/add",
        name: "WhiteAdd",
        component: () => import("@/views/member/white-list/add-edit.vue"),
        meta: {
          name: "新增白名单",
          hidden: true,
          activeMenu: "/member/white-list",
        },
      },
      {
        path: "/member/white-list/edit/:id?",
        name: "WhiteEdit",
        component: () => import("@/views/member/white-list/add-edit.vue"),
        meta: {
          name: "编辑白名单",
          hidden: true,
          activeMenu: "/member/white-list",
        },
      },
      {
        path: "/member/black-list",
        name: "BlackList",
        component: () => import("@/views/member/black-list/list.vue"),
        meta: { name: "黑名单列表", keepAlive: true },
      },
      {
        path: "/member/black-list/add",
        name: "BlackAdd",
        component: () => import("@/views/member/black-list/add-edit.vue"),
        meta: {
          name: "新增黑名单",
          hidden: true,
          activeMenu: "/member/black-list",
        },
      },
      {
        path: "/member/black-list/edit/:id?",
        name: "BlackEdit",
        component: () => import("@/views/member/black-list/add-edit.vue"),
        meta: {
          name: "编辑黑名单",
          hidden: true,
          activeMenu: "/member/black-list",
        },
      },
      {
        path: "/member/order-remark-list",
        name: "OrderRemarkList",
        component: () => import("@/views/member/order-remark/list.vue"),
        meta: { name: "订单备注", keepAlive: true },
      },
    ],
  },
  {
    path: "/order",
    name: "Order",
    component: () => import("@/views/order/index.vue"),
    meta: { name: "订单管理", icon: "el-icon-s-order" },
    children: [
      {
        path: "/order/order-list",
        name: "OrderList",
        component: () => import("@/views/order/order-list/list.vue"),
        meta: { name: "订单列表", keepAlive: true },
      },
      {
        path: "/order/detail/:id?",
        name: "OrderDetail",
        component: () => import("@/views/order/order-list/detail.vue"),
        meta: {
          name: "订单详情",
          hidden: true,
          keepAlive: true,
          activeMenu: "/order/order-list",
        },
      },
      {
        path: "/order/delivery/:id?",
        name: "OrderDelivery",
        component: () => import("@/views/order/order-list/delivery.vue"),
        meta: { name: "发货", hidden: true, activeMenu: "/order/order-list" },
      },
      {
        path: "/order/delivery_store/:id?",
        name: "OrderDeliveryPick",
        component: () => import("@/views/order/order-list/delivery-pick.vue"),
        meta: {
          name: "门店自提",
          hidden: true,
          activeMenu: "/order/order-list",
        },
      },
      {
        path: "/order/order-bill/:id?",
        name: "OrderBill",
        component: () => import("@/views/order/order-list/bill.vue"),
        meta: { name: "账单", hidden: true, activeMenu: "/order/order-list" },
      },
      {
        path: "/order/order-list/update-goods/:id?",
        name: "OrderUpdateGoods",
        component: () =>
          import("@/views/order/order-list/modules/update-goods.vue"),
        meta: {
          name: "修改商品",
          hidden: true,
          activeMenu: "/order/order-list",
        },
      },
      {
        path: "/order/contract-detail/:id?",
        name: "OrderContractDetail",
        component: () => import("@/views/order/order-list/contract-detail.vue"),
        meta: {
          name: "合同凭证",
          hidden: true,
          activeMenu: "/order/order-list",
        },
      },
      {
        path: "/order/bill-list",
        name: "BillList",
        component: () => import("@/views/order/bill-list/list.vue"),
        meta: { name: "账单列表", keepAlive: true },
      },
    ],
  },
  {
    path: "/rental-management",
    name: "RentalManagement",
    redirect: "/rental-management/today-follow-up",
    component: () => import("@/views/rental-management/index.vue"),
    meta: { name: "租中管理", icon: "el-icon-folder-opened" },
    children: [
      {
        path: "/rental-management/today-follow-up",
        name: "TodayFollowUp",
        component: () =>
            import("@/views/rental-management/today-follow-up/list.vue"),
        meta: { name: "今日待跟进账单" },
      },
      {
        path: "/rental-management/customer-service-overdue",
        name: "CustomerServiceOverdue",
        component: () =>
            import("@/views/rental-management/customer-service-overdue/list.vue"),
        meta: { name: "客服跟进逾期订单" },
      },
      {
        path: "/rental-management/collection-follow-up",
        name: "CollectionFollowUp",
        component: () =>
            import("@/views/rental-management/collection-follow-up/list.vue"),
        meta: { name: "催收跟进订单" },
      },
      {
        path: "/rental-management/legal-litigation",
        name: "LegalLitigation",
        component: () =>
            import("@/views/rental-management/legal-litigation/list.vue"),
        meta: { name: "法务诉讼订单" },
      },
      {
        path: "/rental-management/outsourced-follow-up",
        name: "OutsourcedFollowUp",
        component: () =>
            import("@/views/rental-management/outsourced-follow-up/list.vue"),
        meta: { name: "委外跟进订单" },
      },
      {
        path: "/rental-management/debt-transfer",
        name: "DebtTransfer",
        component: () =>
            import("@/views/rental-management/debt-transfer/list.vue"),
        meta: { name: "债转订单" },
      },
      {
        path: "/rental-management/idle-pending",
        name: "IdlePending",
        component: () =>
            import("@/views/rental-management/idle-pending/list.vue"),
        meta: { name: "空置待处理订单" },
      },
      {
        path: "/rental-management/after-sales-details",
        name: "AfterSalesDetails",
        component: () =>
            import("@/views/rental-management/after-sales-details/list.vue"),
        meta: { name: "售后明细" },
      },
    ],
  },
  {
    path: "/finance",
    name: "Finance",
    component: () => import("@/views/finance/index.vue"),
    meta: { name: "财务管理", icon: "el-icon-coin" },
    children: [
      {
        path: "/finance/bill",
        name: "FinanceBill",
        component: () => import("@/views/finance/bill/list.vue"),
        meta: { name: "财务流水" },
      },
      {
        path: "/finance/bill/add",
        name: "FinanceBillAdd",
        component: () => import("@/views/finance/bill/add.vue"),
        meta: { name: "添加流水", hidden: true, activeMenu: "/finance/bill" },
      },
      {
        path: "/finance/order",
        name: "FinanceOrder",
        component: () => import("@/views/finance/order/list.vue"),
        meta: { name: "账单管理" },
      },
      {
        path: "/finance/reserve",
        name: "FinanceReserve",
        component: () => import("@/views/finance/reserve/list.vue"),
        meta: { name: "订单挂账" },
      },
      {
        path: "/finance/store/settle",
        name: "FinanceStoreSettle",
        component: () => import("@/views/finance/store/settle/list.vue"),
        meta: { name: "门店结算管理" },
      },
    ],
  },
  {
    path: "/review",
    name: "Review",
    component: () => import("@/views/review/index.vue"),
    meta: { name: "审核管理", icon: "el-icon-s-platform" },
    children: [
      {
        path: "/review/order-list",
        name: "ReviewOrderList",
        component: () => import("@/views/review/order-list/list.vue"),
        meta: { name: "审核列表" },
      },
      {
        path: "/review/order-detail/:id?",
        name: "ReviewOrderDetail",
        component: () => import("@/views/review/order-list/detail.vue"),
        meta: {
          name: "审核详情",
          hidden: true,
          keepAlive: true,
          activeMenu: "/review/order-list",
        },
      },
      {
        path: "/review/update-goods/:id?",
        name: "ReviewUpdateGoods",
        component: () => import("@/views/review/order-list/modules/update-goods.vue"),
        meta: {
          name: "修改商品",
          hidden: true,
          activeMenu: "/review/order-list",
        },
      },
      {
        path: "/review/assign/list",
        name: "ReviewAssignList",
        component: () => import("@/views/review/review-assign/list.vue"),
        meta: { name: "审核明细", keepAlive: true },
      },
      {
        path: "/review/rule/list",
        name: "ReviewRuleList",
        component: () => import("@/views/review/review-rule/list.vue"),
        meta: { name: "规则配置", keepAlive: true },
      },
      {
        path: "/review/rule/add",
        name: "ReviewRuleAdd",
        component: () => import("@/views/review/review-rule/add-edit.vue"),
        meta: {
          name: "新增规则",
          hidden: true,
          activeMenu: "/review/rule/list",
        },
      },
      {
        path: "/review/rule/edit/:id?",
        name: "ReviewRuleEdit",
        component: () => import("@/views/review/review-rule/add-edit.vue"),
        meta: {
          name: "编辑规则",
          hidden: true,
          activeMenu: "/review/rule/list",
        },
      },
      {
        path: "/review/rule/detail/:id?",
        name: "ReviewRuleDetail",
        component: () => import("@/views/review/review-rule/detail.vue"),
        meta: {
          name: "规则详情",
          hidden: true,
          activeMenu: "/review/rule/list",
        },
      },
    ],
  },
  {
    path: "/store",
    name: "Store",
    component: () => import("@/views/store/index.vue"),
    meta: { name: "门店管理", icon: "el-icon-shopping-cart-2" },
    children: [
      {
        path: "/store/list",
        name: "StoreList",
        component: () => import("@/views/store/store-list/list.vue"),
        meta: { name: "门店列表" },
      },
      {
        path: "/store/add",
        name: "StoreAdd",
        component: () => import("@/views/store/store-list/add-edit.vue"),
        meta: { name: "新增门店", hidden: true, activeMenu: "/store/list" },
      },
      {
        path: "/store/edit/:id?",
        name: "StoreEdit",
        component: () => import("@/views/store/store-list/add-edit.vue"),
        meta: { name: "编辑门店", hidden: true, activeMenu: "/store/list" },
      },
      {
        path: "/store/goods1/list",
        name: "StoreGoods1List",
        component: () => import("@/views/store/goods/list1.vue"),
        meta: { name: "3C商品" },
      },
      {
        path: "/store/goods1/add",
        name: "StoreGoods1Add",
        component: () => import("@/views/store/goods/add-edit1.vue"),
        meta: {
          name: "新增3C商品",
          hidden: true,
          activeMenu: "/store/goods1/list",
        },
      },
      {
        path: "/store/goods1/edit/:id?",
        name: "StoreGoods1Edit",
        component: () => import("@/views/store/goods/add-edit1.vue"),
        meta: {
          name: "编辑3C商品",
          hidden: true,
          activeMenu: "/store/goods1/list",
        },
      },
      {
        path: "/store/goods2/list",
        name: "StoreGoods2List",
        component: () => import("@/views/store/goods/list2.vue"),
        meta: { name: "电车商品" },
      },
      {
        path: "/store/goods2/add",
        name: "StoreGoods2Add",
        component: () => import("@/views/store/goods/add-edit2.vue"),
        meta: {
          name: "新增电车商品",
          hidden: true,
          activeMenu: "/store/goods2/list",
        },
      },
      {
        path: "/store/goods2/edit/:id?",
        name: "StoreGoods2Edit",
        component: () => import("@/views/store/goods/add-edit2.vue"),
        meta: {
          name: "编辑电车商品",
          hidden: true,
          activeMenu: "/store/goods2/list",
        },
      },
      {
        path: "/store/calculate",
        name: "StoreCalculate",
        component: () => import("@/views/store/calculate/index.vue"),
        meta: { name: "方案计算器" },
      },
      {
        path: "/store/combo/list",
        name: "StoreComboList",
        component: () => import("@/views/store/combo/list.vue"),
        meta: { name: "门店方案管理" },
      },
      {
        path: "/store/goods/attr/list",
        name: "StoreGoodsAttrList",
        component: () => import("@/views/store/goods-attr/list.vue"),
        meta: { name: "商品属性管理" },
      },
    ],
  },
  {
    path: "/merchant",
    name: "Merchant",
    redirect: "/merchant/merchant-list",
    component: () => import("@/views/merchant/index.vue"),
    meta: { name: "商户管理", icon: "el-icon-s-shop" },
    children: [
      {
        path: "/merchant/merchant-list",
        name: "MerchantList",
        component: () => import("@/views/merchant/merchant-list/list.vue"),
        meta: { name: "商户列表" },
      },
      {
        path: "/merchant/merchant-list/add",
        name: "MerchantAdd",
        component: () => import("@/views/merchant/merchant-list/add-edit.vue"),
        meta: {
          name: "新增商户",
          hidden: true,
          activeMenu: "/merchant/merchant-list",
        },
      },
      {
        path: "/merchant/merchant-list/edit/:id?",
        name: "MerchantEdit",
        component: () => import("@/views/merchant/merchant-list/add-edit.vue"),
        meta: {
          name: "编辑商户",
          hidden: true,
          activeMenu: "/merchant/merchant-list",
        },
      },
    ],
  },
  {
    path: "/capital",
    name: "Capital",
    component: () => import("@/views/capital/index.vue"),
    meta: { name: "资方管理", icon: "el-icon-s-custom" },
    children: [
      {
        path: "/capital/capital-list/list",
        name: "CapitalList",
        component: () => import("@/views/capital/capital-list/list.vue"),
        meta: { name: "资方列表" },
      },
      {
        path: "/capital/capital-bill/list",
        name: "CapitalBillList",
        component: () => import("@/views/capital/capital-bill/list.vue"),
        meta: { name: "动账明细" },
      },
      {
        path: "/capital/order-list/list",
        name: "CapitalOrderList",
        component: () => import("@/views/capital/order-list/list.vue"),
        meta: { name: "订单列表" },
      },
      {
        path: "/capital/capital-withdraw/list",
        name: "CapitalWithdrawList",
        component: () => import("@/views/capital/capital-withdraw/list.vue"),
        meta: { name: "资方提现" },
      },
    ],
  },
  {
    path: "/operation",
    name: "Operation",
    component: () => import("@/views/operation/index.vue"),
    meta: { name: "运营管理", icon: "el-icon-s-finance" },
    children: [
      {
        path: "/operation/ad",
        name: "OprtAdList",
        component: () => import("@/views/operation/ad/list.vue"),
        meta: { name: "广告设置" },
      },
      {
        path: "/operation/lease",
        name: "OprtLeaseList",
        component: () => import("@/views/operation/lease/list.vue"),
        meta: { name: "运营文案" },
      },
      {
        path: "/operation/contract",
        name: "OprtContractList",
        component: () => import("@/views/operation/contract/list.vue"),
        meta: { name: "协议合同" },
      },
      {
        path: "/operation/goodsBrand/list",
        name: "GoodsBrandList",
        component: () => import("@/views/operation/goods-brand/list.vue"),
        meta: { name: "商品品牌管理" },
      },
    ],
  },
  {
    path: "/order-mall",
    name: "OrderMall",
    component: () => import("@/views/order-mall/index.vue"),
    meta: { name: "网销订单", icon: "el-icon-s-marketing" },
    children: [
      {
        path: "/order-mall/order-list",
        name: "OrderMallList",
        component: () => import("@/views/order-mall/order-list/list.vue"),
        meta: { name: "订单列表", keepAlive: true },
      },
    ],
  },
  {
    path: "/system-manage",
    name: "SystemManage",
    redirect: "/system-manage/dict/list",
    component: () => import("@/views/system-manage/index.vue"),
    meta: { name: "系统设置", icon: "el-icon-setting" },
    children: [
      {
        path: "/system-manage/dict/list",
        name: "DictList",
        component: () => import("@/views/system-manage/dict/list.vue"),
        meta: { name: "字典管理" },
      },
      {
        path: "/system-manage/dict/add-edit",
        name: "DictAddOrEdit",
        component: () => import("@/views/system-manage/dict/add-edit.vue"),
        meta: {
          hidden: true,
          name: "字典管理",
          activeMenu: "/system-manage/dict/list",
        },
      },
      {
        path: "/system-manage/dict/value/list",
        name: "DictValueList",
        component: () => import("@/views/system-manage/dict/value/list.vue"),
        meta: {
          hidden: true,
          name: "字典值管理",
          activeMenu: "/system-manage/dict/list",
        },
      },
      {
        path: "/system-manage/dict/value/add-edit",
        name: "DictValueAddOrEdit",
        component: () => import("@/views/system-manage/dict/value/add-edit.vue"),
        meta: {
          hidden: true,
          name: "字典值管理",
          activeMenu: "/system-manage/dict-manage/list",
        },
      },
      {
        path: '/system-manage/wxcp/msgTpl',
        name: 'SystemWxcpMsgTpl',
        component: () => import('@/views/system-manage/wxcp/msg-tpl.vue'),
        meta: { name: '企微设置' }
      },
      {
        path: "/system-manage/log/list",
        name: "SystemLogList",
        component: () => import("@/views/system-manage/log/list.vue"),
        meta: { name: "操作日志" },
      },
    ],
  },
  {
    path: "/power-manage",
    name: "PowerManage",
    redirect: "/power-manage/user/list",
    component: () => import("@/views/power-manage/index.vue"),
    meta: { name: "权限管理", icon: "el-icon-s-check" },
    children: [
      {
        path: "/power-manage/user/list",
        name: "UserList",
        component: () => import("@/views/power-manage/user/list.vue"),
        meta: { name: "管理员" },
      },
      {
        path: "/power-manage/user/add",
        name: "UserAdd",
        component: () => import("@/views/power-manage/user/add-edit.vue"),
        meta: {
          name: "新增管理员",
          hidden: true,
          activeMenu: "/power-manage/user/list",
        },
      },
      {
        path: "/power-manage/user/edit/:id?",
        name: "UserEdit",
        component: () => import("@/views/power-manage/user/add-edit.vue"),
        meta: {
          name: "编辑管理员",
          hidden: true,
          activeMenu: "/power-manage/user/list",
        },
      },
      {
        path: "/power-manage/role/list",
        name: "RoleList",
        component: () => import("@/views/power-manage/role/list.vue"),
        meta: { name: "角色管理" },
      },
      {
        path: "/power-manage/role/add",
        name: "RoleAdd",
        component: () => import("@/views/power-manage/role/add-edit.vue"),
        meta: {
          name: "新增",
          hidden: true,
          activeMenu: "/power-manage/role/list",
        },
      },
      {
        path: "/power-manage/role/edit/:id?",
        name: "RoleEdit",
        component: () => import("@/views/power-manage/role/add-edit.vue"),
        meta: {
          name: "编辑",
          hidden: true,
          activeMenu: "/power-manage/role/list",
        },
      },
      {
        path: "/power-manage/menu/list",
        name: "MenuList",
        component: () => import("@/views/power-manage/menu/list.vue"),
        meta: { name: "菜单管理", keepAlive: true },
      },
      {
        path: "/power-manage/menu/add/:menuId?/:parentId?",
        name: "MenuAdd",
        component: () => import("@/views/power-manage/menu/add-edit.vue"),
        meta: {
          name: "新增",
          hidden: true,
          activeMenu: "/power-manage/menu/list",
        },
      },
      {
        path: "/power-manage/menu/edit/:menuId?/:parentId?",
        name: "MenuEdit",
        component: () => import("@/views/power-manage/menu/add-edit.vue"),
        meta: {
          name: "编辑",
          hidden: true,
          activeMenu: "/power-manage/menu/list",
        },
      },
      {
        path: "/power-manage/dept/list",
        name: "DeptList",
        component: () => import("@/views/power-manage/dept/list.vue"),
        meta: { name: "部门管理" },
      },
    ],
  },
];
